//painel-admin-src-CarrinhoContext.js

import React, { createContext, useState, useEffect, useMemo } from "react";

export const CarrinhoContext = createContext();

export function CarrinhoProvider({ children }) {
  const usuario = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("usuario")) || null;
    } catch {
      return null;
    }
  }, []);

  const storageKey = usuario?.id ? `carrinho_${usuario.id}` : "carrinho_guest";

  let carrinhoInicial = [];
  const carrinhoSalvo = localStorage.getItem(storageKey);

  if (carrinhoSalvo) {
    try {
      const dados = JSON.parse(carrinhoSalvo);
      const agora = new Date().getTime();
      const expirado = agora - dados.timestamp > 48 * 60 * 60 * 1000;

      if (!expirado) {
        carrinhoInicial = Array.isArray(dados.itens) ? dados.itens : [];
      } else {
        localStorage.removeItem(storageKey);
      }
    } catch (err) {
      console.error("Erro ao carregar carrinho do localStorage:", err);
      localStorage.removeItem(storageKey);
    }
  }

  const [carrinho, setCarrinho] = useState(carrinhoInicial);

  useEffect(() => {
    const dados = {
      itens: carrinho,
      timestamp: new Date().getTime(),
    };
    localStorage.setItem(storageKey, JSON.stringify(dados));
  }, [carrinho, storageKey]);

  const adicionarAoCarrinho = (premio, quantidade = 1) => {
    if (!premio || typeof premio.id === "undefined") return;

    const itemComCamposEssenciais = {
      id: premio.id,
      nome: premio.nome,
      imagem: premio.imagem,
      preco_unitario: premio.preco_unitario,
      valor_em_pontos: premio.valor_em_pontos || null,
      valor_em_pontos_promocional: premio.valor_em_pontos_promocional || null,
      promocao_inicio: premio.promocao_inicio || null,
      promocao_fim: premio.promocao_fim || null,
      peso_kg: premio.peso_kg || null,
      comprimento_cm: premio.comprimento_cm || null,
      largura_cm: premio.largura_cm || null,
      altura_cm: premio.altura_cm || null,
      frete_gratis: premio.frete_gratis || false,
      quantidade,
      exige_voltagem: premio.exige_voltagem || 0,
      voltagens_disponiveis: premio.voltagens_disponiveis || null,
      voltagem: premio.voltagem || "",
    };

    setCarrinho((prev) => {
      const existente = prev.find((item) => item.id === premio.id);
      if (existente) {
        return prev.map((item) =>
          item.id === premio.id
            ? {
                ...item,
                ...itemComCamposEssenciais,
                quantidade: item.quantidade + quantidade,
                voltagem: item.voltagem || "",
              }
            : item
        );
      }
      return [...prev, itemComCamposEssenciais];
    });
  };

  const removerDoCarrinho = (id) => {
    setCarrinho((prev) => prev.filter((item) => item.id !== id));
  };

  const limparCarrinho = () => setCarrinho([]);

  const atualizarQuantidade = (id, novaQuantidade) => {
    setCarrinho((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantidade: Math.max(1, novaQuantidade) }
          : item
      )
    );
  };

      const atualizarVoltagem = (id, voltagem) => {
      setCarrinho((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, voltagem } : item
        )
      );
    };

  return (
    <CarrinhoContext.Provider
      value={{
        carrinho,
        adicionarAoCarrinho,
        removerDoCarrinho,
        limparCarrinho,
        atualizarQuantidade,
        atualizarVoltagem,
      }}
    >
      {children}
    </CarrinhoContext.Provider>
  );
}